export default __webpack_public_path__ + "static/media/comment.ec6a724b.svg";